import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import { ListItemTextStyled } from 'shared/mui/ContextMenu/ContextMenu.styled';
import { ListItemIcon } from 'shared/mui/List';
import { MenuItem, MenuItemProps } from 'shared/mui/MenuItem/MenuItem';

export type ContextMenuButtonProps = {
  onClick?: VoidFunction;
  label: string;
  icon: React.ReactNode;
} & MenuItemProps;

export const ContextMenuButton: React.FC<ContextMenuButtonProps> = ({
  onClick,
  label,
  icon,
  ...restProps
}) => {
  const { onCloseMenu } = useContextMenuContext();
  const handleClick = () => {
    onClick?.();
    onCloseMenu();
  };

  return (
    <MenuItem onClick={handleClick} {...restProps}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemTextStyled primary={label} />
    </MenuItem>
  );
};
